import { AppLayout } from '@/components/layout/AppLayout'
import { Toaster } from '@/components/ui/sonner'
import { useMobileDetection } from '@/hooks/useMobileDetection'
// import { useSelectionHistory } from '@/hooks/useSelectionHistory'
// import { useSelectionPersistence } from '@/hooks/useSelectionPersistence'

function App() {
  useMobileDetection()
  // useSelectionHistory()
  // useSelectionPersistence()

  return (
    <>
      <AppLayout />
      <Toaster position="bottom-center" richColors closeButton />
    </>
  )
}

export default App
